export default "__VITE_ASSET__a8313b8d__"